import React, {
    useCallback, useEffect, useState,useContext
} from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { Icon, Loader } from '@jutro/components';
import { BreakpointTrackerContext } from '@jutro/layout';
import { renderContentFromMetadata } from '@jutro/uiconfig';
import { getFontIcon } from '../../../../../module/nexus-portals-util-js/lobIconUtil';
import { withAuthenticationContext } from 'gw-digital-auth-react';
import { useDependencies } from 'gw-portals-dependency-react';
import metadata from './AccountDocumentSummaryPage.metadata.json5';
import styles from './AccountDocumentSummaryPage.module.scss';
import AccountDocumentSummary from '../AccountDocumentSummary/AccountDocumentSummary';
import PageBannerComponent
    from '../../../../../../components/PageBannerComponent/PageBannerComponent';

const getPolicyNumber = (document) => {
    const iconName= getFontIcon(document.lob);
    return (
        <div className={styles.accordionTabHeadingWrapper}>
            <div><Icon icon={iconName} className={styles.headerIcon} /></div>
            <span className={styles.accordionTabHeading}>
                Policy #&nbsp;
                { document.policyNumber }
            </span>
        </div>
    );
};

function AccountDocumentSummaryPage(props) {
    const { authHeader } = props;
    const { PolicyService } = useDependencies('PolicyService');
    let pageRef = React.createRef();

    // screen states
    const [isLoading, setLoadingState] = useState(false);
    const [pageLoaded, setPageLoaded] = useState(false);

    // fetched data
    const [accountDocumentDataFromApi, setAccountDocumentDataFromApi] = useState([]);

    const generatePolicyCardOverrides = useCallback(() => {
        const overrides = accountDocumentDataFromApi.map((accountPolicy, index) => {
            return {
                [`policyNumber${index}`]: {
                    content: getPolicyNumber(accountPolicy)
                },
                [`accordionTab${index}`]: {
                    id: `accordionTab${index}`, // accountPolicy.policyNumber,
                    type: 'element',
                    component: 'AccordionCard',
                    header: getPolicyNumber(accountPolicy),
                    content: [
                        {
                            id: `documentContentFor${accountPolicy.policyNumber}`,
                            type: 'container',
                            component: AccountDocumentSummary,
                            componentProps: {
                                value: accountPolicy,
                                showFileUpload: false,
                                layout: ['1', '1', '1', '1']
                            }
                        }
                    ]
                }
            };
        });

        return Object.assign({}, ...overrides);
    }, [accountDocumentDataFromApi]);

    useEffect(() => {
        setLoadingState(true);               
        Promise.all([
            //PolicyService.getAccountDocuments(authHeader).then(setAccountDocumentDataFromApi)
            PolicyService.getUserDocuments_EY(authHeader).then(setAccountDocumentDataFromApi)
        ]).finally(() => {
            setLoadingState(false);
            });
    }, []);

    useEffect(() => {        
        if(!pageLoaded && pageRef.current) {
            //document.title = "Customer Enagage Account Management - Policy Documents";
            const element = ReactDOM.findDOMNode(pageRef.current).parentNode; 
            window.setTimeout(() => {
                element.children.docList.focus()
            }, 1000);
            setPageLoaded(true);
        } 
    }, [pageRef]);

    if (isLoading) {
        return <Loader loaded={!isLoading} />;
    }

    const getBackButton = () => {
        const breakpoint = useContext(BreakpointTrackerContext);
        return breakpoint === 'desktop' ? 'Back' : ''
    };

    const overrideProps = {

        backButton: {
            content: getBackButton()
        },
        agentCompany: {
            content: 'ABC Insurance Brokers Ltd'
        },
        agentName: {
            content: 'MARTHA STEWART, CIP'
        },
        agentAddressLine1: {
            content: '123 Main Street, Ajax, ON, JSM 509'
        },
        agentPhone: {
            content: 'Phone: 905-352-6784'
        },
        agentEmail: {
            content: 'Email: martha.stewart@insurance.com'
        },
        noDataMessageContainer: {
            visible: accountDocumentDataFromApi.length === 0
        },
        repeataccordion: {
            data: accountDocumentDataFromApi,
            defaultOpenedId: 'accordionTab0',
            accordionStates: ['accordionTab0', 'accordionTab1', 'accordionTab2', 'accordionTab3', 'accordionTab4', 'accordionTab5', 'accordionTab6', 'accordionTab7', 'accordionTab8']
        },
        ...generatePolicyCardOverrides(),
    };

    const resolvers = {
        resolveClassNameMap: styles,
        resolveComponentMap: {
            pagebannercomponent: PageBannerComponent
        }
    };

    return (
        <div>
            <div id="docList" role="navigation" title="Landed Documents Page" tabindex="0" ref={pageRef}></div>
            {renderContentFromMetadata(metadata.pageContent, overrideProps, resolvers)}
        </div>
    );
    
}

AccountDocumentSummaryPage.propTypes = {
    match: PropTypes.shape({
        params: PropTypes.shape({
            streamId: PropTypes.string
        })
    }).isRequired,
    history: PropTypes.shape({
        push: PropTypes.func
    }).isRequired,
    authHeader: PropTypes.shape({}).isRequired
};

export default withAuthenticationContext(withRouter(AccountDocumentSummaryPage));
